(ns ui.fx.interval
  (:require
   [re-frame.core :as rf]))

(defonce intervals (atom {}))

(rf/reg-fx
 ::interval
 (fn [{:keys [id event delay-ms]}]
   (when-some [existing (get @intervals id)]
     (js/clearInterval existing)
     (swap! intervals dissoc id))
   (when (some? event)
     (swap! intervals assoc id (js/setInterval #(rf/dispatch event) delay-ms)))))

(rf/reg-fx
 ::clear-interval
 (fn [id]
   (if-some [existing-interval (get @intervals id)]
     (js/clearInterval existing-interval)
     (js/console.log (str "no interval to clear found for id " id)))))
